const HelperText = (props) => {
	// ** Props
	const { error, helperText } = props;

	return (
		(!!error || !!helperText) && (
			<span
				className={(!!error && 'text-danger') || (!!helperText && 'text-dark')}
				style={{ fontSize: 'smaller', fontFamily: 'Poppins Medium' }}
			>
				{error || helperText}
			</span>
		)
	);
};

export default HelperText;
